import React, { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

type ContainerProps = ComponentPropsWithoutRef<'div'>;

function Container(props: ContainerProps, ref) {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(props.className, 'container')}
    />
  );
}

export default React.forwardRef<HTMLDivElement, ContainerProps>(Container);
